import React from 'react'
import {AutoGrowingInput} from './auto-growing-text-input'
import {StringStickerSettingsInputProps} from './types'

export const StringStickerSettingsInput = (
  props: StringStickerSettingsInputProps
) => {
  const inputClassName =
    'leading-4 border-bg-main-old focus-within:border-bg-main-old'
  const spanClassName = 'leading-4 pr-8 pl-8 text-12'
  const inputContainerStyle = {
    paddingLeft: '4px',
    paddingRight: '4px',
    fontSize: '12px'
  }

  return (
    <AutoGrowingInput
      inputClassName={inputClassName}
      spanClassName={spanClassName}
      inputContainerStyle={inputContainerStyle}
      minWidth={'min-w-[130px]'}
      maxWidth={'max-w-458'}
      {...props}
    />
  )
}
